import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { DrugAllergyModel } from 'app/EMR/HistoryModels/drugallergy.model';
import { HelplistService } from 'app/helplist.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Observable, Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-drug-allergy',
  templateUrl: './drug-allergy.component.html',
  styleUrls: ['./drug-allergy.component.scss']
})
export class DrugAllergyComponent implements OnInit {
 private filteredOptions_drugs: Observable<DrugAllergyModel[]>;
 private filteredOptions_drugsEdit: Observable<DrugAllergyModel[]>;
 private drugallergy_ds: MatTableDataSource<DrugAllergyModel>
 private displayedColumns_drugallergy: string[] = ['saltname', 'comments', 'Action'];
 private DrugControl = new FormControl();
 private DrugControl1 = new FormControl();
 private editCache: { [key: string]: any } = {};
 private destroydrug$: Subject<boolean> = new Subject<boolean>();
 private checkinputValue: String;
 private enabledisablebtn: boolean = false;
 private druglist: DrugAllergyModel[] = []; 
 showspinner:boolean=false;
 isheader:boolean=false;
 @Input() showdruallergymodel:any;
 @Output() parentdata :EventEmitter<any> = new EventEmitter();
 @Output() drugEmitter = new EventEmitter<() => void>();
  constructor(private emrservice: EMRService,
    private dashboardService: DashboardService, private dialog: MatDialog,
    private opdvisitService: OpdVisitService ,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DrugAllergyComponent>,) {
    // for drugs or salt
      this.drugList(0,0);
      
  }

  ngOnInit(): void {
    const drug_historyFun = () => {
      this.get_drugallergy();
    };
    this.drugEmitter.emit(drug_historyFun);
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.emrservice.drugallergy_added={};
    this.enabledisablebtn = true;
    this.checkinputValue = '';
    this.emrservice.drugallergy_added.saltName = '';
    this.emrservice.drugallergy_added.comments = '';
    this.drugallergy_ds = new MatTableDataSource(this.emrservice.drugallergy.slice());
    this.emrservice.drugAllergydata = this.arraytostringConversion(this.emrservice.drugallergy.map(person => person.saltName));
    this.drugupdateEdit();
    
  }

   drugList(type,seachtype){
    this.druglist=[];
     this.emrservice.getsalthName(type,seachtype).pipe(takeUntil(this.destroydrug$)).subscribe((data)=>{
      this.druglist =data;
      this.filteredOptions_drugs = this.DrugControl.valueChanges
      .pipe(
        startWith(null),
        map(drug => drug ? this._filterdrugs(drug, 1) : this.druglist.slice())
      );
      this.filteredOptions_drugsEdit = this.DrugControl1.valueChanges
      .pipe(startWith(null), map(drug => drug ? this._filterdrugs(drug, 2) : this.druglist.slice())
      );
     },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
     })
   }

  get_drugallergy() {
    this.emrservice.get_allergies().pipe(takeUntil(this.destroydrug$)).subscribe(
      data => this.success_drugallergy(data), err => this.failed_drugallergy(err)
    )
  }

  success_drugallergy(data) {

    this.emrservice.drugallergy = data;
    this.drugallergy_ds = new MatTableDataSource(this.emrservice.drugallergy.slice());
    this.emrservice.drugAllergydata = this.arraytostringConversion(this.emrservice.drugallergy.map(person => person.saltName));
    this.drugupdateEdit();
  }

  failed_drugallergy(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  arraytostringConversion(drname: any) {
    if (drname.length > 0) {
      var drdata = '';
      drname.forEach(item => {
        drdata += item + ',';
      })
      return drdata;
    } else {
      return null;
    }

  }
  getid(drug) {
    // this.checkinputValue =event.id;
    this.emrservice.drugallergy_added.FKSaltId = drug.pkSaltId;
    this.emrservice.drugallergy_added.saltName = drug.saltName;
  }
  CheckinputRef(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.emrservice.drugallergy_added.saltName = null;

      this.filteredOptions_drugs = this.DrugControl.valueChanges
        .pipe(
          startWith(null),
          map(drug => drug ? this._filterdrugs(drug, 1) : this.druglist.slice())
        );
    }
  }
  newdrugArray: any = [];
  private _filterdrugs(value: string, type): DrugAllergyModel[] {
    
    if (value && (typeof value != 'number')) {
      const filterValue = value.toLowerCase();
      const returndata = this.druglist.filter(country =>
        country.saltName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && value.length >= 3) {
        this.emrservice.getsalthName(value,0).subscribe((x: any) => {
          this.newdrugArray = [];
          this.newdrugArray = x;
          if (type == 1) {
            this.filteredOptions_drugs = this.DrugControl.valueChanges
              .pipe(
                startWith(""),
                map(cat => this.newdrugArray.slice())
              );
          } else if (type == 2) {
            this.filteredOptions_drugsEdit = this.DrugControl1.valueChanges
              .pipe(
                startWith(""),
                map(cat => this.newdrugArray.slice())
              );
          }

        })
      } else {
        return returndata;
      }
    }
  }

  adddrug() {

    let a = this.druglist.filter(item => item.saltName == this.emrservice.drugallergy_added.saltName);
    let b = this.newdrugArray.filter(item => item.saltName == this.emrservice.drugallergy_added.saltName);
    if ((a.length == 0 || this.emrservice.drugallergy_added.saltName == undefined || this.emrservice.drugallergy_added.saltName == "") && b.length == 0) {
      return this.dashboardService.openSnackBar("Please select the salt name ", "Ok")
    }
    const isDuplicate = this.emrservice.drugallergy.some((entry:any) =>{
      return entry.saltName == this.emrservice.drugallergy_added.saltName;
    });
    if (isDuplicate) {
      return this.dashboardService.openSnackBar("Already exists in the list ", "Ok")
    }
    this.enabledisablebtn = false;
    this.setdefault_values_drug_allergy();
    this.emrservice.drugallergy.push(this.emrservice.drugallergy_added);
    this.emrservice.drugallergy_added = {};
    this.drugallergy_ds = new MatTableDataSource(this.emrservice.drugallergy.slice());
    this.drugupdateEdit();
    this.checkinputValue = "";
    document.getElementById("drugAllergyModal").style.display = "none";  
  }

  setdefault_values_drug_allergy() {
    this.emrservice.drugallergy_added.FKRegId = this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.drugallergy_added.pKTranId = 0

    for (let a of this.druglist) {
      if (a.saltName == this.emrservice.drugallergy_added.saltName) {
        this.emrservice.drugallergy_added.FKSaltId = a.pkSaltId;
        return
      }
    }

    //  let a = this.emrservice.druglist.filter
    // (item => item.saltName === this.emrservice.drugallergy_added.saltName);

    //  console.log ("salt id  " + this.emrservice.drugallergy_added.FKSaltId);

    //console.log ("salt id " + a[0].FKSaltId);
    //this.emrservice.drugallergy_added.FKSaltId = a[0].FKSaltId;
    // this.emrservice.drugallergy_added.FKSaltId = 11
  }



  deletedrug(row) {
    if (this.emrservice.drughistoryPermission?.isDeletePermission == true) {
      if (row.pK_TranId > 0) {
        this.emrservice.delete_allergy_on_server(row.pK_TranId).pipe(takeUntil(this.destroydrug$)).subscribe(
          data => this.success_delete_drug(data), err => this.failed_delete_drug(err)
        )
      } else {
        const index: number = this.emrservice.drugallergy.indexOf(row);
        if (index !== -1) {
          this.emrservice.drugallergy.splice(index, 1);
          this.drugallergy_ds = new MatTableDataSource(this.emrservice.drugallergy.slice());
        }
      }
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }
  success_delete_drug(data) {
    this.enabledisablebtn = true;
    this.get_drugallergy();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");

  }
  failed_delete_drug(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  save_drug_toserver() {

    let drugPayloads = [];
    let drugeditpayload;
    let drugPayload = this.emrservice.drugallergy.filter(item => item.pKTranId == 0);
    if (drugPayload.length > 0) {
      // this.emrservice.open_loader_Dialog();
      this.showspinner = true;
      drugPayload.forEach(element => {
        drugPayloads.push({
          "saltName": element.saltName,
          "comments": element.comments ? element.comments : '',
          "FKRegId": element.FKRegId,
          "pKTranId": element.pKTranId,
          "FKSaltId": element.FKSaltId,
          "isEdit":element.pKTranId >0?true:false
        })
      });

      drugeditpayload = drugPayloads;
      this.emrservice.save_allergies_to_server(drugeditpayload).pipe(takeUntil(this.destroydrug$)).subscribe(
        data => this.success_drugs_saved(data), err => this.failed_drugs_saved(err)
      )
    } else {
      this.dialog.closeAll();
      return this.dashboardService.openSnackBar("Please Add the salt name ", "Ok");
    }
  }
  success_drugs_saved(data) {
    this.enabledisablebtn = true;
    // this.dialog.closeAll();
    this.showspinner = false;
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.get_drugallergy();
    if(data.length >0 || data.statusCode == 1){
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    }
    else if (data.statusCode == 10) {
      this.dashboardService.openSnackBar("Already exists in the list", "OK");
    }

  }
  failed_drugs_saved(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dialog.closeAll();
    // console.log("insert drugs api failed");
  }


  drugAllergy() {
    if (this.emrservice.drughistoryPermission?.isAddPermission == true) {
      document.getElementById("drugAllergyModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  canceldrugAllergy() {
    document.getElementById("drugAllergyModal").style.display = "none";
    this.emrservice.drugallergy_added = {}
  }

  addDrugitem() {
    this.adddrug();
  }
  drugupdateEdit(): void {

    this.drugallergy_ds.data.forEach((item, index) => {
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  Edit(index) {
    if (this.emrservice.drughistoryPermission?.isModifyPermission == true) {
      const id = index;
      this.drugupdateEdit();
      this.editCache[id].edit = true;
    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }

  drugSaveEdit(idx): void {
    const id = idx;
    let payloadarray = [];
    let editpayload;
    let saltname;
    let comment;
    let fK_RegId;
    let pK_TranId;
    let editlist = this.editCache[id].data;

    if (editlist.pKTranId == 0) {
      saltname = editlist.saltName;
      comment = editlist.comments ? editlist.comments : '';
      fK_RegId = editlist.FKRegId;
      pK_TranId = editlist.pKTranId;
    } else {
      saltname = editlist.saltName;
      comment = editlist.comments ? editlist.comments : '';
      fK_RegId = editlist.fK_RegId;
      pK_TranId = editlist.pK_TranId;
    }
    let saltId;
    let saltIdlist = this.druglist.filter(item => item.saltName == saltname);
    if (saltIdlist.length > 0) {
      saltId = saltIdlist[0].pkSaltId;
    } else {
      return this.dashboardService.openSnackBar("Please select the salt name ", "Ok")
    }

    payloadarray.push({
      "saltName": saltname,
      "comments": comment,
      "FKRegId": fK_RegId,
      "pKTranId": pK_TranId,
      "FKSaltId": saltId,
      "isEdit":pK_TranId > 0?true:false
    })
    this.editCache[id].edit = false;
    editpayload = payloadarray;
    this.emrservice.save_allergies_to_server(editpayload).pipe(takeUntil(this.destroydrug$)).subscribe(
      data => this.success_drugs_update(data), err => this.failed_drugs_update(err)
    )
  }
  success_drugs_update(data) {
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.get_drugallergy();
    if(data.length >0 || data.statusCode == 1){
      this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
    }
    else if (data.statusCode == 10) {
    this.dashboardService.openSnackBar("Already exists in the list", "OK");
    } 
  }
  failed_drugs_update(err) {
    
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  cancelEdit(idx): void {
    const id = idx;
    this.editCache[id].edit = false;
  }
  ngOnDestroy() {
    this.destroydrug$.next(true);
    this.destroydrug$.unsubscribe();
    this.filteredOptions_drugs = null;
    this.filteredOptions_drugsEdit = null;
    this.drugallergy_ds = null;
    this.displayedColumns_drugallergy = null;
    this.editCache = null;
    this.checkinputValue = null;
    this.druglist =null;
    this.checkinputValue = null
    this.DrugControl = null;
    this.DrugControl1 = null;
  }
  closedialog(){
    this.dialogRef.close();
  }
}
